import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import CurrentFilters from '../../elements/CurrentFilters';
import FilterButton from '../../elements/FilterButton';
import PageSizeDropdown from '../../elements/PageSizeDropdown';
import SearchStats from '../../elements/SearchStats';
import SortByDropdown from '../../elements/SortByDropdown';
import { LinkSmall } from '@styled';

import { getAlgoliaIndexNameGlobal } from '@general/helpers/search.helpers';
import { SearchTypeContext } from '../../../context/searchTypeContext';
import { PageSizeContext, SearchModeContext, SortByContext, AttendeeModeContext } from '../../../context/searchContext';
import useEventAttendeePdf from '../../../hooks/useEventAttendeePdf';

const SearchOptionsMobile = ({ onFilterButtonClick, onPageSizeChange, onSortByChange }) => {
    const [searchType] = useContext(SearchTypeContext);
    const [sortBy] = useContext(SortByContext);
    const [pageSize] = useContext(PageSizeContext);
    const indexName = getAlgoliaIndexNameGlobal(searchType.index);
    const { showFilters } = useContext(SearchModeContext);

    const attendeeModeContext = useContext(AttendeeModeContext);
    const { eventAttendeePdf } = useEventAttendeePdf(attendeeModeContext?.event);

    return (
        <div className="mt-3">
            <div className="align-self-center mb-3 text-center">
                <SearchStats />
            </div>

            {showFilters && (
                <div className="mb-3">
                    <FilterButton
                        onClick={() => {
                            if (onFilterButtonClick) {
                                onFilterButtonClick();
                            }
                        }}
                    />
                </div>
            )}

            <div className="mb-3">
                <CurrentFilters buttonClasses="display8" clearAllClasses="display9" />
            </div>

            <div className="listing-filters d-flex justify-content-between">
                <li className="nav-item dropdown d-inline-block my-md-auto mr-md-5 align-self-center">
                    <SortByDropdown
                        items={[]}
                        defaultRefinement={`${indexName}${sortBy.indexSuffix}`}
                        onSortByChange={onSortByChange}
                    />
                </li>

                <li className="nav-item dropdown d-inline-block my-md-auto mr-md-5 align-self-center">
                    <PageSizeDropdown
                        items={[]}
                        defaultRefinement={pageSize.hitsPerPage}
                        onPageSizeChange={onPageSizeChange}
                    />
                </li>
            </div>

            <div className="d-flex justify-content-center">
                {eventAttendeePdf && (
                    <LinkSmall href={eventAttendeePdf} className="text-sm" id="attendee-pdf-download" target="_blank">
                        Attendee List (pdf)
                    </LinkSmall>
                )}
            </div>
        </div>
    );
};

SearchOptionsMobile.propTypes = {
    onFilterButtonClick: PropTypes.func,
    onPageSizeChange: PropTypes.func.isRequired,
    onSortByChange: PropTypes.func.isRequired,
};

export default SearchOptionsMobile;
